import React from 'react';
import parse from 'html-react-parser';

import { Country } from '../../../base/interfaces/config';
import { __t } from '../../../base/utils/t';
import { HelperModal } from '../../../base/components/HelperModal';

import './styles.scss';

interface Props {
    title: string;
    countries: Country[];
    selectedCountries: Country[];
    className?: string;
    selectHandler: (value: Country[]) => void;
}

export const CountriesSelect = ({ title, countries, selectedCountries, className = '', selectHandler }: Props) => {
    const selectAllHandler = () => selectHandler([]);

    const tabClickHandler = (country: Country) => {
        if (selectedCountries.some((i) => i.id === country.id)) {
            selectHandler(selectedCountries.filter((i) => i.id !== country.id));
            return;
        }

        selectHandler([...selectedCountries, country]);
    };

    return (
        <div className={`application-country-select ${className}`}>
            <h1 className='application-country-select__title'>{title}</h1>
            <div className='application-country-select__top-wrap'>
                <div
                    className={`application-country-select__select-tab ${
                        !selectedCountries.length ? 'application-country-select__select-tab--selected' : ''
                    }`}
                    onClick={selectAllHandler}
                >
                    <div className='application-country-select__select-tab-icon flag flag_icon_eu'></div>
                    {__t('Все страны')}
                </div>
                <HelperModal icon='info-circle' className='application-country-select__select-helper-modal'>
                    {__t('Вы можете выбрать Все страны, одну или несколько стран')}
                </HelperModal>
            </div>
            <div className='application-country-select__select-tabs-container application-country-select__select-tabs-container--flags'>
                {countries.map((country) => (
                    <div key={country.id}>
                        <div
                            className={`application-country-select__select-tab ${
                                selectedCountries.some((c) => c.id === country.id)
                                    ? 'application-country-select__select-tab--selected'
                                    : ''
                            }`}
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => tabClickHandler(country)}
                        >
                            <div className='application-country-select__select-tab-icon flag'>
                                {parse(country.flag)}
                            </div>

                            {country.name}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
